import React from 'react';
import '../css/footer.css'; // Importing custom styles
import '@fortawesome/fontawesome-free/css/all.min.css';

const Footer = () => {
  const socialLinks = [
    { label: 'Facebook', icon: 'fab fa-facebook-f' },
    { label: 'Twitter', icon: 'fab fa-twitter' },
    { label: 'Instagram', icon: 'fab fa-instagram' },
    { label: 'LinkedIn', icon: 'fab fa-linkedin-in' },
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column">
          <h3>KimTour</h3>
          <p>
            A Kimberley city guide for places to stay, eat, explore, shop, and
            plan memorable local journeys.
          </p>
          <p className="footer-sponsor">Sponsored by Sol Plaatje Municipality.</p>
        </div>
        
    
        

        <div className="footer-column">
          <h3>Contact Us</h3>
          <p>Email: info@kimtour.com</p>
          <p>Phone: (074) 456-7890</p>
        </div>

        <div className="footer-column">
          <h3>Follow Us</h3>
          <div className="footer-socials">
            {socialLinks.map((link) => (
              <button type="button" aria-label={link.label} key={link.label}>
                <i className={link.icon} aria-hidden="true"></i>
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2026 KimTour. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
